module.exports = __webpack_public_path__ + "img/ReportProblemOutlined.7c1c753e.svg";